module.exports = __webpack_public_path__ + "static/img/SketchPngbb9b1b5b909e33d45d91a10213a97e4ee64bf99288f3c0e135b7cf93ae171748.3f8eaddd.png";